import React, { useEffect, useState } from "react";
import { config } from "../../../config";
import { ButtonsRight } from "../../../interfaces/UI";
import { useUser } from "../../../hooks";


enum AreaTrigger{
    wide = 'wide'
    , narrow = 'narrow'
}

enum Aligment{
    justify = 'justify'
    , left = 'left'
}

enum TxtSize{
    def = 'def'
    , mid = 'mid'
    , big = 'big'
}

enum Thema{
    light = 'light'
    , dark = 'dark'
    , highContrast = 'highContrast'
    , sunglow = 'sunglow'
}

interface UserOptionsProps {
  openButtons: ButtonsRight;
  setOpenButtons :  (buttosn : ButtonsRight) => void
}

const UserOptions = ({ openButtons, setOpenButtons }: UserOptionsProps) => {


    const htmlTag = document.querySelector("html")
    const [readerArea, setReaderArea] = useState<AreaTrigger>(AreaTrigger.wide)
    const [layout, setLayout] = useState<Number>(1)
    const [aligment, setAligment] = useState<Aligment>(Aligment.justify)
    const [txtSize, setTxtSize] = useState<TxtSize>(TxtSize.def)
    const [thema, setThema] = useState<Thema>(Thema.light)
    const [viewPerfil, setViewPerfil] = useState<Boolean>(false)
    const {user} = useUser();

    useEffect(() => {
      if(user){
        setViewPerfil(true)
      }
    }, [user])

    const changeReadingArea = ( areaTrigger : AreaTrigger) =>{
        if(htmlTag){
            htmlTag.dataset.areasize = `area-${areaTrigger}`
        }
        setReaderArea(areaTrigger)
    }

    const changeLayout = ( layoutTrigger: number) =>{
        if(htmlTag){
            htmlTag.dataset.layout = `col-${layoutTrigger}`
        }
        setLayout(layoutTrigger)
    }

    const changeAligment = ( layoutTrigger: Aligment) =>{
        if(htmlTag){
            htmlTag.dataset.alignment = `align-${layoutTrigger}`
        }
        setAligment(layoutTrigger)
    }    

    const changeTxtSize = ( layoutTrigger: TxtSize) =>{
        if(htmlTag){
            htmlTag.dataset.txtsize = `tsize-${layoutTrigger}`
        }
        setTxtSize(layoutTrigger)
    }    

    const changeThema = ( layoutTrigger: Thema) =>{
        if(htmlTag){
            htmlTag.dataset.theme = `theme-${layoutTrigger}`
        }
        setThema(layoutTrigger)
    }    

  return (
    <div
      id="option-0"
      className={`aside__content ${openButtons.optConfig ? "active" : ""}`}
    >
      <div className="aside__content-header">
        <h3>Opciones de usuario</h3>
        <button
          className="btn btn-rounded btn-rounded-transparent btn-close"
          aria-label="Cerrar panel de opciones de personalización"
          onClick = { ()=>{
              let tmpBtns : ButtonsRight = {...openButtons}
              tmpBtns.optConfig = false 
              setOpenButtons( tmpBtns ) 
            } }
        >
          <span className="btn__icon">
            <i className="icon icon-vpro-close"></i>
          </span>
        </button>
      </div>
      <div className="aside__content-data main-sb">


        {/* <!-- submenu usuario --> */}
        <div className="dd-submenu">

            {viewPerfil?(
                <div className="dd-submenu__header">
                    <div className="card-user card-user--horizontal">
                    <div className="card-user__type">
                        <h2>Suscripción Institucional</h2>
                        <span>Premium</span>
                    </div>
                    <div className="card-user__profile">
                        <div className="card-user__profile-avatar-wrapper">
                        <div className="card-user__profile-avatar">
                            <a href="/">
                            <img width={100} src={ user?.sus_foto ||  "/images/avatar.jpg"} alt="Foto de perfil" />
                            </a>
                        </div>
                        </div>

                        <div className="card-user__profile-data">
                        <a className="card-user__name" href="/">
                            {user?.sus_nombre}
                        </a>
                        <a className="card-user__email" href="/">
                            {user?.sus_email}
                        </a>
                        </div>
                    </div>
                    </div>
                </div>
            ):null}

          <div className="dd-submenu__body">
            <ul className="dd-submenu-menu">

            {/* -------------- */}
            {/* IDIOMA */}
            {/* -------------- */}                
              {/* <li className="dd-submenu-menu__item">
                <span className="dd-submenu-menu__label">Idioma</span>
                <div className="dd-submenu-menu__controls">
                  <button
                    type="button"
                    className="btn btn-control tippy"
                    data-tippy-content="Español"
                    aria-label="Idioma Español"
                  >
                    ES
                  </button>
                  <button
                    type="button"
                    className="btn btn-control tippy"
                    data-tippy-content="Inglés"
                    aria-label="Idioma Inglés"
                  >
                    EN
                  </button>
                  <button
                    type="button"
                    className="btn btn-control tippy"
                    data-tippy-content="Portugués"
                    aria-label="Idioma Portugués"
                  >
                    PT
                  </button>
                </div>
              </li> */}

            {/* -------------- */}
            {/* AREA DE LECTURA */}
            {/* -------------- */}
              <li className="dd-submenu-menu__item">
                <span className="dd-submenu-menu__label">Area de lectura</span>
                <div className="dd-submenu-menu__controls">
                  <button
                    type="button"
                    className= {`btn btn-control artrigger tippy ${readerArea==AreaTrigger.wide?"selected":""}`}
                    data-tippy-content="Ampliar area"
                    data-area="wide"
                    aria-label="Area de lectura amplia"
                    onClick = { ()=> changeReadingArea(AreaTrigger.wide) }
                  >
                    <span className="btn__icon">
                      <i className="icon icon-sys-wide"></i>
                    </span>
                  </button>
                  <button
                    type="button"
                    className = {`btn btn-control artrigger tippy ${readerArea==AreaTrigger.narrow?"selected":""}`}
                    data-tippy-content="Reducir area"
                    data-area="narrow"
                    aria-label="Area de lectura estrecha"
                    onClick = { ()=> changeReadingArea(AreaTrigger.narrow) }
                  >
                    <span className="btn__icon">
                      <i className="icon icon-sys-narrow"></i>
                    </span>
                  </button>
                </div>
              </li>


            {/* -------------- */}
            {/* LAYOUT */}
            {/* -------------- */}
              <li className="dd-submenu-menu__item">
                <span className="dd-submenu-menu__label">Layout</span>
                <div className="dd-submenu-menu__controls">
                  <button
                    type="button"
                    className= {`btn btn-control ctrigger tippy ${layout==1?"selected":""}`}
                    data-tippy-content="Layout de una columna"
                    data-slayout="1"
                    aria-label="Contenido en una columna"
                    onClick = { ()=> changeLayout(1) }
                  >
                    <span className="btn__icon">
                      <i className="icon icon-sys-1col"></i>
                    </span>
                  </button>
                  <button
                    type="button"
                    className= {`btn btn-control ctrigger tippy ${layout==2?"selected":""}`}
                    data-tippy-content="Layout de dos columna"
                    data-slayout="2"
                    aria-label="Contenido en dos columnas"
                    onClick = { ()=> changeLayout(2) }

                  >
                    <span className="btn__icon">
                      <i className="icon icon-sys-2col"></i>
                    </span>
                  </button>
                  <button
                    type="button"
                    className= {`btn btn-control ctrigger tippy ${layout==3?"selected":""}`}
                    data-tippy-content="Layout de tres columna"
                    data-slayout="3"
                    aria-label="Contenido en 3 columnas"
                    onClick = { ()=> changeLayout(3) }
                  >
                    <span className="btn__icon">
                      <i className="icon icon-sys-3col"></i>
                    </span>
                  </button>
                </div>
              </li>

            {/* -------------- */}
            {/* JUSTIFICACION */}
            {/* -------------- */}
              <li className="dd-submenu-menu__item">
                <span className="dd-submenu-menu__label">Justificación</span>
                <div className="dd-submenu-menu__controls">
                  <button
                    type="button"
                    className= {`btn btn-control atrigger tippy ${aligment==Aligment.left?"selected":""}`}
                    data-tippy-content="Alinear textos a la izquierda"
                    data-salignment="left"
                    aria-label="Alinear textos a la izquierda"
                    onClick = { ()=> changeAligment(Aligment.left) }
                    
                    >
                    <span className="btn__icon">
                      <i className="icon icon-sys-txt-left"></i>
                    </span>
                  </button>
                  <button
                    type="button"
                    className= {`btn btn-control atrigger tippy ${aligment==Aligment.justify?"selected":""}`}
                    data-tippy-content="Justificar textos"
                    data-salignment="justify"
                    aria-label="Justificar textos"
                    onClick = { ()=> changeAligment(Aligment.justify) }
                  >
                    <span className="btn__icon">
                      <i className="icon icon-sys-txt-justify"></i>
                    </span>
                  </button>
                </div>
              </li>

            {/* -------------- */}
            {/* TAMAÑO DE FUENTE */}
            {/* -------------- */}
              <li className="dd-submenu-menu__item">
                <span className="dd-submenu-menu__label">Tamaño fuente</span>
                <div className="dd-submenu-menu__controls">
                  <button
                    type="button"
                    className= {`btn btn-control fstrigger tippy ${txtSize==TxtSize.def?"selected":""}`}
                    data-tippy-content="Fuente pequeña"
                    data-tsize="def"
                    aria-label="Tamaño de fuente pequeña"
                    onClick = { ()=> changeTxtSize(TxtSize.def) }
                    
                    >
                    <span className="btn__icon">
                      <i className="icon icon-vpro-font-size-sm"></i>
                    </span>
                  </button>
                  <button
                    type="button"
                    className= {`btn btn-control fstrigger tippy ${txtSize==TxtSize.mid?"selected":""}`}
                    data-tippy-content="Fuente mediana"
                    data-tsize="mid"
                    aria-label="Tamaño de fuente mediana"
                    onClick = { ()=> changeTxtSize(TxtSize.mid) }
                  >
                    <span className="btn__icon">
                      <i className="icon icon-vpro-font-size-md"></i>
                    </span>
                  </button>
                  <button
                    type="button"
                    className= {`btn btn-control fstrigger tippy ${txtSize==TxtSize.big?"selected":""}`}
                    data-tippy-content="Fuente grande"
                    data-tsize="big"
                    aria-label="Tamaño de fuente grande"
                    onClick = { ()=> changeTxtSize(TxtSize.big) }
                  >
                    <span className="btn__icon">
                      <i className="icon icon-vpro-font-size-lg"></i>
                    </span>
                  </button>
                </div>
              </li>

            {/* -------------- */}
            {/* THEMA */}
            {/* -------------- */}              
              <li className="dd-submenu-menu__item">
                <button
                  type="button"
                  className= {`btn btn-rounded btn--outline ft-tlight ttrigger tippy ${thema==Thema.light?"selected":""}`}
                  data-tippy-content="Tema claro"
                  data-tema="light"
                  aria-label="Seleccionar tema claro"
                  onClick = { ()=> changeThema(Thema.light) }
                ></button>
                <button
                  type="button"
                  className= {`btn btn-rounded btn--outline ft-tdark ttrigger tippy ${thema==Thema.dark?"selected":""}`}
                  data-tippy-content="Tema oscuro"
                  data-tema="dark"
                  aria-label="Seleccionar tema oscuro"
                  onClick = { ()=> changeThema(Thema.dark) }
                ></button>
                <button
                  type="button"
                  className= {`btn btn-rounded btn--outline ft-hc ttrigger tippy ${thema==Thema.highContrast?"selected":""}`}
                  data-tippy-content="Tema alto contraste"
                  data-tema="highContrast"
                  aria-label="Seleccionar tema alto contraste"
                  onClick = { ()=> changeThema(Thema.highContrast) }

                ></button>

                <button
                  type="button"
                  className= {`btn btn-rounded btn--outline ft-sunglow ttrigger tippy ${thema==Thema.sunglow?"selected":""}`}
                  data-tippy-content="Tema sunglow"
                  data-tema="sunglow"
                  aria-label="Seleccionar tema amarillo"
                  onClick = { ()=> changeThema(Thema.sunglow) }
                ></button>
              </li>
            </ul>
          </div>

          <div className="dd-submenu__footer">
            <a type="button" className="btn btn--fw btn-alt-secondary btn--ayuda" href={config.urlSupport} target="_blank">
              <span className="dd-submenu-menu__label">Ir al Centro de soporte</span>
              <i className="icon icon-vpro-new-win"></i>
            </a>
          </div>

        </div>
        {/* <!-- submenu usuario end --> */}
      </div>
      <div className="aside__content-actions">
        {/* <p style={{ fontSize: '1.2rem'}}>Entorno: {config.env}</p>
        <p style={{ fontSize: '1.2rem'}}>Versión: {process.env.REACT_APP_VERSION}</p> */}
      </div>
    </div>
  );
};

export default UserOptions;
